
import React, { useState } from 'react';
import { Tabs } from '@/components/ui/tabs';
import { NewsCategory } from '@/types/news';
import NewsFilter from '@/components/news/NewsFilter';
import NewsTabNavigation from '@/components/news/NewsTabNavigation';
import NewsTabContent from '@/components/news/NewsTabContent';
import { useNewsArticles } from '@/hooks/useNewsArticles';

const availableCategories: Array<{ value: NewsCategory; label: string }> = [
  { value: 'business', label: 'Business' },
  { value: 'industry', label: 'Industry' },
  { value: 'releases', label: 'Releases' },
  { value: 'technology', label: 'Technology' },
  { value: 'streaming', label: 'Streaming' },
  { value: 'charts', label: 'Charts' },
  { value: 'events', label: 'Events' },
  { value: 'legal', label: 'Legal' },
  { value: 'marketing', label: 'Marketing' },
  { value: 'publishing', label: 'Publishing' },
];

const NewsSection: React.FC = () => {
  const [activeTab, setActiveTab] = useState<string>('all');
  const [selectedCategories, setSelectedCategories] = useState<NewsCategory[]>([]);
  const [selectedSources, setSelectedSources] = useState<string[]>([]);
  const itemsPerPage = 9;

  const handleFilterChange = (categories: NewsCategory[], sources: string[]) => {
    setSelectedCategories(categories);
    setSelectedSources(sources);
  };

  const { data, isLoading, isError, page, handleLoadMore } = useNewsArticles({
    activeTab,
    selectedCategories,
    selectedSources,
    itemsPerPage
  });

  return (
    <div>
      <Tabs 
        defaultValue="all" 
        value={activeTab}
        onValueChange={setActiveTab}
        className="space-y-6"
      >
        <NewsTabNavigation activeTab={activeTab} />
        
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
          <div className="hidden lg:block">
            <NewsFilter 
              onFilterChange={handleFilterChange}
              availableCategories={availableCategories}
            />
          </div>
          
          <div className="lg:col-span-3 space-y-8">
            {['all', 'business', 'technology', 'industry', 'trending', 'saved'].map(tabValue => (
              <NewsTabContent 
                key={tabValue}
                tabValue={tabValue}
                isLoading={isLoading}
                isError={isError}
                articles={data?.articles || []}
                totalArticles={data?.total || 0}
                page={page}
                itemsPerPage={itemsPerPage}
                onLoadMore={handleLoadMore}
              />
            ))}
          </div>
        </div>
      </Tabs>
    </div>
  );
};

export default NewsSection;
